import { Box, Plus } from 'lucide-react';
import { Button } from '@/components/Button';
import { EmptyState } from '@/components/EmptyState';
import { StorageUsageFooter } from '@/components/StorageUsageFooter';
import { ModelLibraryBrowser } from '@/features/models';
import { useModels } from '@/features/models/hooks';
import { useUIStore } from '@/stores/ui';
import { CollectionFilterSidebar } from '@/features/collections/components';

export function ModelsPage() {
  const { openAddModelSidebar } = useUIStore();

  const { data, isLoading } = useModels({ page: 1, limit: 1 });

  const modelCount = data?.pagination.total || 0;
  const hasModels = modelCount > 0;

  const handleAddModel = () => {
    openAddModelSidebar();
  };

  return (
    <div className="h-full flex flex-col overflow-hidden">
      {/* Page header - Full width */}
      <div className="flex-shrink-0 p-4 border-b border-border">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-lg font-semibold text-foreground">Models</h1>
            <p className="text-sm text-foreground-muted">
              Manage your 3D models
            </p>
          </div>
          <Button size="sm" leftIcon={<Plus className="h-4 w-4" />} onClick={handleAddModel}>
            Add Model
          </Button>
        </div>
      </div>

      {/* Content area with models and sidebar */}
      <div className="flex-1 flex overflow-hidden">
        {/* Collection Filter Panel - Left side */}
        <CollectionFilterSidebar />

        {/* Main Content */}
        <div className="flex-1 overflow-y-auto p-4">
          {isLoading && !hasModels ? (
            <div className="rounded border border-border bg-background-subtle p-12 text-center">
              <p className="text-foreground-muted">Loading models...</p>
            </div>
          ) : !hasModels ? (
            <div className="rounded border border-border bg-background-subtle p-4">
              <EmptyState
                icon={<Box className="h-10 w-10" />}
                title="No models yet"
                description="Add your first 3D model to your library. Upload STL and 3MF files or link models from MakerWorld, Printables, and Thingiverse."
                actionLabel="Add Model"
                onAction={handleAddModel}
              />
            </div>
          ) : (
            <ModelLibraryBrowser />
          )}
        </div>
      </div>

      {/* Storage usage footer */}
      <StorageUsageFooter />
    </div>
  );
}
